
// Filter Input Option Data
const FilterOptionData = {};

FilterOptionData.launchDate={
    week: 'last week',
    month: 'last month',
    year: 'last year',
}
FilterOptionData.status={
    failure: 'failure',
    success: 'success',
}
export default FilterOptionData;